
import { Component, Vue } from 'nuxt-property-decorator'
import type { MetaInfo } from 'vue-meta'
import { OnMounted, WithHead } from '~/core/vue.types'
import MainBanner from '~/components/MainBanner/MainBanner.vue'
import SaveRouteMixin from '~/mixins/save-route.mixin'
import FeaturesBanner, { FeaturesBannerItem } from '~/components/sections/FeaturesBanner.vue'
import HowItWorks from '~/components/main-page/HowItWorks.vue'
import { useSEOMetaComposer } from '~/composables/seo.composable'

const HappyClients = () => ({ component: import(/* webpackChunkName: "sections" */ '~/components/sections/HappyClients.vue'), delay: 200, timeout: 3000 })

@Component({
  components: {
    MainBanner,
    HappyClients,
    FeaturesBanner,
    HowItWorks,
  },
  mixins: [SaveRouteMixin],
  nuxtI18n: {
    paths: {
      en: '/how-it-works/',
      de: '/wie-funktioniert-es/',
      fr: '/comment-ca-marche/',
    },
  },
})
export default class HowItWorksPage extends Vue implements WithHead, OnMounted {
  private featuresBannerItems: FeaturesBannerItem[] = [
    {
      icon: require('~/assets/images/icons/features-banner/features-banner-icon-target.svg'),
      title: this.$t('credibilityCards.1.title') as string,
      description: this.$t('credibilityCards.1.description') as string,
    },
    {
      icon: require('~/assets/images/icons/features-banner/features-banner-icon-calculator.svg'),
      title: this.$t('credibilityCards.2.title') as string,
      description: this.$t('credibilityCards.2.description') as string,
    },
    {
      icon: require('~/assets/images/icons/features-banner/features-banner-icon-time.svg'),
      title: this.$t('credibilityCards.3.title') as string,
      description: this.$t('credibilityCards.3.description') as string,
    },
    {
      icon: require('~/assets/images/icons/features-banner/flag-banner.svg'),
      title: this.$t('credibilityCards.4.title') as string,
      description: this.$t('credibilityCards.4.description') as string,
    },
  ]

  private featureBannersStyles = {
    '--features-icon-size': '46px',
    '--features-padding-y': '2.25rem',
  }

  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.$t('head.meta.howItWorks.title').toString(),
        description: this.$t('head.meta.howItWorks.description').toString(),
        route: { name: 'how-it-works' },
      },
    )
  }

  mounted () {
    this.$analytics.GTM.sendPageViewEvent({
      routeName: this.$route.name as string,
      pageTitle: this.$metaInfo.title || '',
      fullPath: this.$route.fullPath,
      fromPath: this.$nuxt.context.from ? this.$nuxt.context.from.fullPath : '',
      contentGroup: 'About us',
    })
  }
}
